"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Instrument = exports.GenericEvents = void 0;
var _init = require("../../../common/config/init");
var _drain = require("../../../common/drain/drain");
var _instrumentBase = require("../../utils/instrument-base");
var _constants = require("../constants");
/* Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

class Instrument extends _instrumentBase.InstrumentBase {
  static featureName = _constants.FEATURE_NAME;
  constructor(agentIdentifier, aggregator, auto = true) {
    super(agentIdentifier, aggregator, _constants.FEATURE_NAME, auto);
    const genericEventSourceConfigs = [(0, _init.getConfigurationValue)(this.agentIdentifier, 'page_action.enabled')
    // other future generic event source configs to go here, like M&Ms, PageResouce, etc.
    ];
    /** If any of the sources are active, import the aggregator. otherwise deregister */
    if (genericEventSourceConfigs.some(x => x)) this.importAggregator();else (0, _drain.deregisterDrain)(this.agentIdentifier, this.featureName);
  }
}
exports.Instrument = Instrument;
const GenericEvents = exports.GenericEvents = Instrument;